import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import AlertBullet from "components/AlertBullet/AlertBullet";

const style = ({ theme }) => ({
  root: {
    display: "flex",
    alignItems: "center",
    borderRadius: 0,
    borderBottom: `2px solid ${theme.colors.tertiary4}`,
    backgroundColor: theme.colors.quinary3,
    color: theme.colors.tertiary1,
    padding: [theme.padding.sm, 0],
    fontFamily: theme.fonts.serif,
    fontSize: "14px"
  },
  body: {
    padding: [0, theme.padding.sm],
    flexGrow: 1,
    "& p": {
      fontWeight: theme.fontWeights.bold,
      fontFamily: theme.fonts.sans
    }
  }
});

/**
 * TODO: Theme support
 */
const Hint = ({ classes, children }) => (
  <div className={classes.root}>
    <AlertBullet />
    <div className={classes.body}>{children}</div>
  </div>
);

Hint.themes = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TERTIARY: "tertiary",
  QUATERNARY: "quanternary" // Spelling is wrong in theme
};

Hint.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  theme: PropTypes.oneOf(Object.entries(Hint.themes).map(([key, val]) => val))
};

Hint.defaultProps = {
  theme: Hint.themes.PRIMARY
};

export default injectSheet(style)(Hint);
